import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appClipboard]'
})
export class ClipboardDirective {
  @Input() target: HTMLInputElement;
  @Output() success = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();

  @HostListener('click') onClick() {
    try {
      this.target.select();
      document.execCommand('copy');
      this.success.emit(true);
    } catch (e) {
      this.error.emit(true);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/clipboard.directive.ts